<template>
  <!-- --------------------------------------------------------- -->
  <!-- ---------------- Page Header ----------------------------- -->
  <!-- --------------------------------------------------------- -->

  <div class="mainPageDiv" style="background-color: #f0f4fa; border: 3px solid #668cff;">

    <!-- ----------------- title ------------------- -->

    <div class="pageHeader" style="color: white; background-color: #668cff;">
      Person Documents:
    </div>

    <!-- ----------------- data grid ------------------- -->

    <div style="padding: 15px;">

      <div class="flexRowNoWrapCenter">

        <div>Add Document:</div>

        <div @click="handleUploadDocument" class="material-icons forIconNewRecord text-success" data-tooltip="tooltip"
          title="Upload Document">
          add_card
        </div>

        <div style="margin-left: 20px">
          <input :checked="!showAllRecords" type="radio" style="margin-right: 10px;" @click="handleUniqueRadioClick"
            id="radioActiveButtonID" name="recordsToShow" aria-labelledby="mostrecent" />

          <label for="setup" id="mostrecent">Show Most Recent of each Type</label>
        </div>

        <div style="margin-left: 20px">
          <input :checked="showAllRecords" type="radio" style="margin-right: 10px;" @click="handleAllRadioClick"
            id="radioAllButtonID" name="recordsToShow" aria-labelledby="showall"/>

          <label for="setup" id="showall">Show Complete Document List</label>
        </div>

      </div>

      <!-- --------------------------------------------------------- -->
      <!-- ---------------- Data Grid ------------------------------ -->
      <!-- --------------------------------------------------------- -->

      <ApplicationGrid :GridData="gridTime" 
                       :EnablePaging="EnablePaging" 
                       :EnableSearching="EnableSearching" 
                       :EnableSorting="EnableSorting"
                       :HeaderArrays="headerArrays" 
                       :CenterGridSlots="centerGridSlots" 
                       :EnableSettings="false">

        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <!-- +++++++++++++++ grid slots START +++++++++++++++ -->
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++ -->

        <!-- --------------------------------------------------- -->
        <!-- ---------- centerGrid0 (acodqcVerified) ----------- -->
        <!-- --------------------------------------------------- -->

        <template v-slot:centerGrid0="slotArgs">

            <div class="activeAgency"
                 :id="'Agency1_a' + slotArgs.itemArg['personDocumentID']"
                 data-tooltip="tooltip"
                 title="Click to Verify/Unverify"
                 style="width: 100%">


                <input type="checkbox"
                       :id="'qcVerifiedCheckbox${slotArgs.itemArg.personDocumentID}'"
                       :checked="slotArgs.itemArg.qcVerified"
                       @change="handleQcVerifiedClick(slotArgs)"  aria-label="Click to Verify/Unverify">

            </div>

        </template>

        <!-- ---------------------------------------------------- -->
        <!-- ---------- centerGrid3 (fullDocumentName) ---------- -->
        <!-- ---------------------------------------------------- -->

        <template v-slot:centerGrid3="slotArgs">

          <div class="activeAgency" 
              :id="'Agency1_d' + 
               slotArgs.itemArg['personDocumentID']" 
               data-tooltip="tooltip"
               @click="downloadDocument(slotArgs)"
            title="Click to open the document" style="width: 100%">

              {{ slotArgs.itemArg['documentName'] }}

          </div>

        </template>

        <!-- <template v-slot:centerGrid3="slotArgs">

          <div class="activeAgency" 
              :id="'Agency1_d' + 
               slotArgs.itemArg['personDocumentID']" 
               data-tooltip="tooltip"
            title="Click to open the document" style="width: 100%">

            <a target="_blank" download :href="getFileURL(slotArgs)">
              {{ slotArgs.itemArg['documentName'] }}
            </a>

          </div>

        </template> -->








        <!-- ++++++++++++++++++++++++++++++++++++++++++++++ -->
        <!-- +++++++++++++++ grid slots END +++++++++++++++ -->
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++ -->

      </ApplicationGrid>

      <!-- <a target="_blank"   
      download  href="https://localhost:8080/caamsng/files/0F98CD2B-B188-4DA4-A0F6-9AC3AACC801F.pdf">
      {{ slotArgs.itemArg['fullDocumentName'] }}
    </a> -->

    </div>

  </div>
  <!-- ----------------------------------------------------------------------------- -->
  <!-- --------------------------- MODAL START ------------------------------------- -->
  <!-- ----------------------------------------------------------------------------- -->

  <div id="xmodal-main-ID" class="xmodal-container-main">
    <div class="xmodal-container-content">

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- HEADER ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="header-primary headerMainContainer">
        <div style="display: inline-block;">&nbsp;</div>
        <div style="color: white; display: inline-block">{{ modalTitle }}</div>
        <div class="cancelModalX" @click="CloseModalUpdateCreate"
          style="margin-right: 10px; color: white; display: inline-block; text-align: right; align-items: end;">X</div>
      </div>

      <hr class="xmodal-hr-top" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- FORM ------------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-container-form">

        <!-- ------- Document Type -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Document Type (required)">
          Document Type:
        </div>

        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <select tabindex="12" id="docTypeId" v-model="selectedDocTypeId" style="margin: 0px; padding: 5px;">
            <option v-for="item in docTypeList" :value="item.id" :key="item.id">
              {{ item.name }}
            </option>
          </select>

          <span v-if="!selectedDocumentTypeUndefined" class="validationErrorAsterisk">*</span>
          <span v-if="selectedDocumentTypeUndefined" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <!-- ------- Select Document: -->
        <div class="xmodal-content-justify-right xmodal-control-labels itemCenterCenter" data-tooltip="tooltip"
          style="margin-top: 10px;" title="Select a File for Upload (Required)">
          <span style="margin-right: 5px;">Select Document</span>
          <UploadAgentSimplified @proccessFiles="handle_proccessFiles">
          </UploadAgentSimplified><span style="margin-left: 2px; font-weight: bold; color: black;"></span> :

        </div>

        <div class="xmodal-content-justify-left xmodal-textbox-padding itemCenterCenter"
          style="padding: 0px; margin: 0px; margin-top: 10px;">
          <input style="color: darkred; font-weight: bold; margin-left: 5px; padding: 5px;" type="text" size="50"
            v-model="selectedFile" aria-label="Select a document">
          <span v-if="!fileValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="fileValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

      </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Validation ------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <hr v-if="validationErrorFound" class="xmodal-hr-bottom" />
      <div v-if="validationErrorFound" class="text-danger xmodal-outer-div">Required fields indicated by asterisk(s).
        The following are validation errors found:
        <div class="xmodal-inner-div">
          <ul class="xmodal-li-validation">
            <li v-if="selectedDocumentTypeUndefined">Please select a document type.</li>
            <li v-if="selectedFileUndefined">Please select a document.</li>
            <li v-if="fileSizeTooBig">File size greater than 5MB. Please choose smaller file.</li>
            <li v-if="fileNameTooLong">File name longer than 150 characters. Please choose file with shorter name..</li>
          </ul>
        </div>
      </div>

      <hr v-if="serverErrorFound" class="xmodal-hr-bottom" />
      <div v-if="serverErrorFound" class="text-danger xmodal-outer-div">
        An error was encountered during file Upload. See the error message below:
        <div class="xmodal-inner-div">
          <textarea id="textareaErrors" style="padding: 10px;" rows="4" cols="80">{{ serverErrorMessage }}</textarea>
        </div>
      </div>

      <hr class="xmodal-hr-bottom" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Footer ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-footer">
        <button type="button" @click="CloseModalUpdateCreate" class="btn-danger">
          Cancel
        </button>
        <button id="xmodal-submit-btn-id" type="button" @click="handleEditClickSubmitBtn" class="btn-primary">
          Upload
        </button>
      </div>
    </div>
  </div>

  <!-- ----------------------------------------------------------------------------- -->
  <!-- --------------------------- MODAL END---------------------------------------- -->
  <!-- ----------------------------------------------------------------------------- -->
</template>

<script>
import axios from "axios";
import { store } from "../../store/store.js"
import ApplicationGrid from "../dataSupport/ApplicationGrid.vue"
import UploadAgentSimplified from "../../components/dataSupport/UploadAgentSimplified.vue";

export default {
  props: {
     EnableSearching: { type: Boolean, defautl: true },
     EnableSorting: { type: Boolean, defautl: true },
     EnablePaging: { type: Boolean, defautl: true },
   },
  data() {
    return {

      // fileServer: 'https://localhost:8080/caamsng/files/',
      fileServer: process.env.VUE_APP_FILES_URL,
      modalTitle: null,

      selectedFile: null,
      selectedSize: null,
      maximumFileSizeAllowed: 5242880,
      maximumFileNameLength: 150,
      fileSizeTooBig: false,
      fileNameTooLong: false,
      fileValidationError: false,

      selectedFullString: null,
      selectedFileUndefined: false,
      selectedDocumentTypeUndefined: false,
      validationErrorFound: false,
      uploadFileList: null,

      serverErrorFound: false,
      serverErrorMessage: null,

      store,
      personId: null,
      userRole: null,
      contractId: null,

      gridTime: { grid: null, time: null },
      docTypeList: null,
      selectedDocTypeId: null,
      baseFileName: null,
      fileExtension: null,
      defaultDocTypeList: { id: -1, name: 'Please Select a Value' },

      showAllRecords: false,

      headerArrays: null,

      //This will hold the results object from the server.
      serverUploadFiles: null,

      //centerGrid0, ..., centerGrid15
      centerGridSlots: [
        { slot: 'centerGrid0', field: 'qcVerified' },
        { slot: 'centerGrid1', field: 'lrVerified' },
        { slot: 'centerGrid2', field: 'lastUpdateEmail' },
        { slot: 'centerGrid3', field: 'documentName' },
      ],

    };
  },

    props: {
        EnableSearching: {
            type: Boolean,
            default: true,
        },
  },
  created() {

    // console.log('process.env.VUE_APP_FILES_URL = ', process.env.VUE_APP_FILES_URL);

    // console.log('DocCmp: store.authenticatedUser: ', store.authenticatedUser);

    this.setHeaderForUser();
    this.personIdFunc();
    this.contractIdFunc();
    this.getGridDataUnique();
    this.getDocumentTypes();

  },

  props: {
    PersonId: { type: Number, require: false },
    ContractId: { type: Number, require: false },
  },

  components: { ApplicationGrid, UploadAgentSimplified },

  Watch: {

    PersonId: {
      handler: function () {
        this.personIdFunc();
      }, deep: true,
    },

    ContractId: {
      handler: function () {
        this.contractIdFunc();
      }, deep: true,
    },

  },

  methods: {

    // ------------------ Add Document ---------------------

    //This is called in response to clicking the create div.The dialog
    //modal is opened due to properties set in the edit div. 
    handleUploadDocument() {
      // console.log('-->> handleUploadDocument()');
      this.clearSelectedFile();

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";
      this.$data.modalTitle = 'Add Document';
    },

    CloseModalUpdateCreate() {
      // console.log("OpenModalFnc()");
      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "none";
      this.clearSelectedFile();
    },

    handle_proccessFiles(filesToUpload) {

      // console.log("**** DocCmp: DocCmp.vue: handle_proccessFiles() ****");

      this.$data.uploadFileList = filesToUpload;

      // console.log('--- DocCmp: handle_proccessFiles() ---');
      // this.log_fileFormData(filesToUpload);

      this.getFileInfoForDisplay(filesToUpload);

      // console.log('111111111111111 DocCmp 22222222222222222');
      // this.$data.uploadFileList.forEach((element) => {
      //   console.log('this.$data.uploadFileList: element = ', element);
      // });
      // console.log('111111111111111 DocCmp 22222222222222222');
    },

    handleEditClickSubmitBtn() {

      this.validateFields();

      if (this.$data.validationErrorFound == false) {
        this.sendFilesToServer();
      } else {
        this.$data.serverErrorFound = false;
        this.$data.serverErrorMessage = null;
      }

    },

    validateFields() {

      this.$data.validationErrorFound = false;

      //Document type
      if ((this.$data.selectedDocTypeId == -1) ||
        (this.$data.selectedDocTypeId == null) ||
        (this.$data.selectedDocTypeId == undefined)) {
        this.$data.validationErrorFound = true;
        this.$data.selectedDocumentTypeUndefined = true;
      } else {
        this.$data.selectedDocumentTypeUndefined = false;
      }

      //Existence of a selected file.
      if ((this.$data.selectedFile == null) ||
        (this.$data.selectedFile == undefined) ||
        (this.$data.selectedFile.trim().length == 0)) {
        this.$data.validationErrorFound = true;
        this.$data.selectedFileUndefined = true;
        this.$data.fileValidationError = true;
      } else {
        this.$data.selectedFileUndefined = false;
      }

      //File size
      if (this.$data.selectedSize > this.$data.maximumFileSizeAllowed) {
        this.$data.validationErrorFound = true;
        this.$data.fileSizeTooBig = true;
        this.$data.fileValidationError = true;
      } else {
        this.$data.fileSizeTooBig = false;
      }

      //File name Length
      if (this.$data.selectedFile.length > this.$data.maximumFileNameLength) {
        this.$data.validationErrorFound = true;
        this.$data.fileNameTooLong = true;
        this.$data.fileValidationError = true;
      } else {
        this.$data.fileNameTooLong = false;
      }

    },

    sendFilesToServer() {

      axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

      return axios.post(store.webAPIUrl + "File/uploadFileObject", this.$data.uploadFileList
      ).then((response) => {
        return response.data;
      }).then((data) => {

        // console.log('***>>> data = ', data);
        // console.log('data.errorFound = ', data.errorFound);
        // console.log('data.uploadResults = ', data.uploadResults);

        if (data.errorFound == true) {
          this.$data.serverErrorFound = true;
          this.$data.serverErrorMessage = data.uploadResults;
        } else {
          this.$data.serverErrorFound = false;
          this.$data.serverErrorMessage = null;
          this.$data.baseFileName = data.baseFileName;
          this.$data.fileExtension = data.fileExtension;

          this.sendFilesToDatabase();
        }
      });
    },

    sendFilesToDatabase() {
      let formData = new FormData();
      formData.append("DocumentName", this.$data.selectedFile);
      formData.append("DocumentTypeId", this.$data.selectedDocTypeId);
      formData.append("DocumentGuid", this.$data.baseFileName);
      formData.append("DocumentMimeType", this.$data.fileExtension);
      formData.append("PersonID", this.$data.personId);
      formData.append("UpdateBy", store.authenticatedUser.userProfileId);
      formData.append("ContractId", this.$data.contractId);

      // console.log('this.$data.selectedFile = ', this.$data.selectedFile);
      // console.log('this.$data.selectedDocTypeId = ', this.$data.selectedDocTypeId);
      // console.log('this.$data.baseFileName = ', this.$data.baseFileName);
      // console.log('this.$data.fileExtension = ', this.$data.fileExtension);
      // console.log('this.$data.personId = ', this.$data.personId);
      // console.log('store.authenticatedUser.userProfileId = ', store.authenticatedUser.userProfileId);
      // console.log('this.$data.contractId = ', this.$data.contractId);

      axios
        .post(store.webAPIUrl + "File/SaveFileToDatabase/", formData)
        .then((response) => response.data)
        .then((data) => {

          if (data.errorFound == true) {
            this.$data.serverErrorFound = true;
            this.$data.serverErrorMessage = data.uploadResults;
          } else {
            this.$data.serverErrorFound = false;
            this.$data.serverErrorMessage = null;
            this.CloseModalUpdateCreate();
            //this.getGridDataAll();
            this.getGridDataUnique();
          }

        });

    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },

    getFileInfoForDisplay(filesToUpload) {
      filesToUpload.forEach((element) => {
        this.$data.selectedFile = element.name;
        this.$data.selectedSize = element.size;

        this.$data.selectedFullString = element.name + '   (Size: ' + this.formatBytes(element.size) + ')';
        // console.log(' DocCmp: getFileInfoForDisplay() -----------');
        // console.log('element.size = ', element.size);
        // console.log('element.name = ', element.name);
      });
      // console.log('-------->> DocCmp: getFileInfoForDisplay(): this.$data.selectedFile = ', this.$data.selectedFile);
    },

    clearSelectedFile() {
      this.$data.selectedFile = null;
      this.$data.selectedFullString = null;
      this.$data.selectedSize = null;
      this.$data.validationErrorFound = false;
      this.$data.selectedDocTypeId = this.$data.defaultDocTypeList.id;
      this.$data.serverErrorFound = false;
      this.$data.serverErrorMessage = null;
      this.$data.fileNameTooLong = false;
      this.$data.fileSizeTooBig = false;
      this.$data.fileValidationError = false;
    },

    getSelectedFileString() {
      return this.$data.selectedFile;
    },

    log_fileFormData(filesToUpload) {
      console.log('####################  DocCmp: log_fileFormData() 99 Start ####################');
      console.log('############## Input File Form Data ###############');
      console.log('filesToUpload = ', filesToUpload);
      filesToUpload.forEach((element) => {
        console.log('-----------');
        console.log('element.size = ', element.size);
        console.log('element.name = ', element.name);
      });
      console.log('############## 99 End ###############');
    },

    getDocumentTypes() {
      // console.log(this);
      // console.log(this.personId)
      axios
        .get(store.webAPIUrl + "PersonDocument/SelAllDocumentType")
        .then((response) => response.data)
        .then((data) => {
          // console.log('DocCmp: getDocumentTypes(): getDocumentTypes(): data = ', data);

          this.$data.docTypeList = new Array();
          this.$data.docTypeList = data;

          //Add the default item to the top of the list.
          this.$data.docTypeList.unshift(this.$data.defaultDocTypeList);
          this.$data.selectedDocTypeId = this.$data.defaultDocTypeList.id;
        });
    },

    // -------------------- Other -------------------

    getFileURL(slotArgs) {

      // console.log('#1');

      let fileName = slotArgs.itemArg['documentGuid'] + slotArgs.itemArg['documentMimeType'];
      let url = this.$data.fileServer + fileName;

      // console.log('DocCmp: getFileURL(): url = ', url);

      return url;
    },

    personIdFunc() {
      if (this.PersonId) {
        this.$data.personId = this.PersonId;
        // console.log('!!!!!!!!!!!!!! this.$data.personId = ', this.$data.personId);
      }
    },

    contractIdFunc() {
      if (this.ContractId) {
        this.$data.contractId = this.ContractId;
        // console.log('!!!!!!!!!!!!!! this.$data.contractId = ', this.$data.contractId);
      }
    },

    setHeaderForUser() {

      this.$data.userRole = store.authenticatedUser.roleName;
      // console.log('setHeaderForUser(): this.$data.userRole = ', this.$data.userRole);

      /* -- code below updated to allow COR users to QC documents and clean up Read-Only display */
      let isVenCor = (this.$data.userRole == 'Vendor') || (this.$data.userRole == "Read-Only");
      let isAdminKo = (this.$data.userRole == 'Admin') || (this.$data.userRole == 'Contract Officer') || (this.$data.userRole == 'Contract Officer Representative');
      //let isVenCor = (this.$data.userRole == 'Vendor') || (this.$data.userRole == 'Contract Officer Representative');
      //let isAdminKo = (this.$data.userRole == 'Admin') || (this.$data.userRole == 'Contract Officer');


      if (isVenCor) {

        this.$data.headerArrays = [
          { defaultShow: false, rawName: 'personDocumentID', displayName: 'Person Document ID', hoverText: 'Database Record ID' },
          { defaultShow: false, rawName: 'personID', displayName: 'Person ID', hoverText: 'Database Person ID' },
          { defaultShow: false, rawName: 'documentTypeId', displayName: 'Document Type Id', hoverText: 'Database Document ID' },
          { defaultShow: true, rawName: 'documentType', displayName: 'Type', hoverText: 'Document Type' },
          { defaultShow: false, rawName: 'documentId', displayName: 'Document Id', hoverText: 'Database Document ID' },
          { defaultShow: false, rawName: 'documentGuid', displayName: 'Document Guid', hoverText: 'Database Document Guid' },
          { defaultShow: true, rawName: 'documentName', displayName: 'Document Name', hoverText: 'Document Name' },
          { defaultShow: false, rawName: 'documentMimeType', displayName: 'Document document Mime', hoverText: 'Document Mime' },
          { defaultShow: false, rawName: 'fullDocumentName', displayName: 'Full Document', hoverText: 'Full Document Name' },
          { defaultShow: true, rawName: 'signExpiration', displayName: 'Signed Date', hoverText: 'Signed Expiration Date' },
          { defaultShow: false, rawName: 'documentExpiration', displayName: 'Expiration Date', hoverText: 'Expiration date for document' },
          { defaultShow: true, rawName: 'updateDate', displayName: 'Update Date', hoverText: 'Date the record was last updated' },
          { defaultShow: false, rawName: 'lastUpdateEmail', displayName: 'UpdateBy', hoverText: 'The person who last updated the document' },
          { defaultShow: false, rawName: 'acodqcVerifiedDate', displayName: 'ACOD QC Verified Date', hoverText: 'ACOD QC Verified Date' },
          { defaultShow: false, rawName: 'acodqcVerified', displayName: 'ACOD QC Verified', hoverText: 'ACOD QC Verified' },
          { defaultShow: false, rawName: 'lrVerifiedDate', displayName: 'LR Verified Date', hoverText: 'LR Verified Date' },
          { defaultShow: false, rawName: 'lrVerified', displayName: 'LR Verified', hoverText: 'LR Verified' },
          { defaultShow: false, rawName: 'qcVerifiedDate', displayName: 'QC Verified Date', hoverText: 'QC Verified Date' },
          { defaultShow: false, rawName: 'qcVerified', displayName: 'QC Verified', hoverText: 'QC Verified' },
          { defaultShow: false, rawName: 'acodqcSelect', displayName: 'ACOD QC Select', hoverText: 'ACOD QC Select' },
          { defaultShow: false, rawName: 'aalNumber', displayName: 'AAL Number', hoverText: 'AAL Number' },
          { defaultShow: false, rawName: 'permitExpire', displayName: 'Permit Expire', hoverText: 'Permit Expire Date' }
        ];

      } else if (isAdminKo) {

        this.$data.headerArrays = [
          { defaultShow: false, rawName: 'personDocumentID', displayName: 'Person Document ID', hoverText: 'Database Record ID' },
          { defaultShow: false, rawName: 'personID', displayName: 'Person ID', hoverText: 'Database Person ID' },
          { defaultShow: false, rawName: 'documentTypeId', displayName: 'Document Type Id', hoverText: 'Database Document ID' },
          { defaultShow: true, rawName: 'documentType', displayName: 'Type', hoverText: 'Document Type' },
          { defaultShow: false, rawName: 'documentId', displayName: 'Document Id', hoverText: 'Database Document ID' },
          { defaultShow: false, rawName: 'documentGuid', displayName: 'Document Guid', hoverText: 'Database Document Guid' },
          { defaultShow: true, rawName: 'documentName', displayName: 'Document Name', hoverText: 'Document Name' },
          { defaultShow: false, rawName: 'documentMimeType', displayName: 'Document document Mime', hoverText: 'Document Mime' },
          { defaultShow: false, rawName: 'fullDocumentName', displayName: 'Full Document', hoverText: 'Full Document Name' },
          { defaultShow: true, rawName: 'signExpiration', displayName: 'Signed Date', hoverText: 'Signed Expiration Date' },
          { defaultShow: false, rawName: 'documentExpiration', displayName: 'Expiration Date', hoverText: 'Expiration date for document' },
          { defaultShow: true, rawName: 'updateDate', displayName: 'Update Date', hoverText: 'Date the record was last updated' },
          { defaultShow: false, rawName: 'lastUpdateEmail', displayName: 'UpdateBy', hoverText: 'The person who last updated the document' },
          { defaultShow: false, rawName: 'acodqcVerifiedDate', displayName: 'ACOD QC Verified Date', hoverText: 'ACOD QC Verified Date' },
          { defaultShow: false, rawName: 'acodqcVerified', displayName: 'ACOD QC Verified', hoverText: 'ACOD QC Verified' },
          { defaultShow: false, rawName: 'lrVerifiedDate', displayName: 'LR Verified Date', hoverText: 'LR Verified Date' },
          { defaultShow: false, rawName: 'lrVerified', displayName: 'LR Verified', hoverText: 'LR Verified' },
          { defaultShow: true, rawName: 'qcVerifiedDate', displayName: 'QC Verified Date', hoverText: 'QC Verified Date' },
          { defaultShow: true, rawName: 'qcVerified', displayName: 'QC Verified', hoverText: 'QC Verified' },
          { defaultShow: false, rawName: 'acodqcSelect', displayName: 'ACOD QC Select', hoverText: 'ACOD QC Select' },
          { defaultShow: false, rawName: 'aalNumber', displayName: 'AAL Number', hoverText: 'AAL Number' },
          { defaultShow: false, rawName: 'permitExpire', displayName: 'Permit Expire', hoverText: 'Permit Expire Date' }
        ];

      }

      // roles:
      //
      //   Admin
      //   Vendor
      //   Contract Officer Representative
      //   Contract Officer
      //   Read-Only      

    },

    getMailtoHref(emailAddress) {
      let returnMailTo = 'mailto:' + emailAddress;
      return returnMailTo;
    },

    getGridDataAll() {
      axios
        .get(store.webAPIUrl + "PersonDocument/SelDocsforPerson/" + this.personId)
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };

          this.$data.gridTime.grid = new Array();
          this.shallowCopyArray(data, this.$data.gridTime.grid);
          this.$data.gridTime.time = new Date().getTime();

          console.log('DocCmp.vue: this.$data.gridTime.grid = ', this.$data.gridTime.grid);
        });
    },

    shallowCopyArray(source, destination) {
      //Both arrays must exist.
      if (source && destination) {
          if (source.length > 0){

              let sourceLength = source.length;

              if (source[0] != null){

                let keys = Object.keys(source[0]);

                if (keys.length > 0) {
                  for (let i = 0; i < sourceLength; i++) {

                      var obj = {};

                      keys.forEach((key) => {
                          obj[key] = source[i][key];
                      });

                      destination.push(obj);
                  }
                }//if (keys.length > 0) {
              }

          }//if (source.length > 0){
      }//if (source && destination) {
    },

    getGridDataUnique() {

      axios
        .get(store.webAPIUrl + "PersonDocument/selLatestDocsforPerson/" + this.$data.personId)
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };

          console.log('getGridDataUnique:  data = ', data);
        });
    },

    handleAllRadioClick() {
      this.$data.showAllRecords = true;
      this.getGridDataAll();
    },

    handleUniqueRadioClick() {
      this.$data.showAllRecords = false;
      this.getGridDataUnique();
    },

    handleQcVerifiedClick(args) {
      
      let personDocumentID = args.itemArg["personDocumentID"];
      this.updatePersonDocumentQcVerified(personDocumentID);

      // console.log(personDocumentID);
    },

    updatePersonDocumentQcVerified(personDocumentID) {

      // console.log('this.$data.showAllRecords = ', this.$data.showAllRecords);
      // console.log('personDocumentID = ', personDocumentID);

      let ctrlID = '#qcVerifiedCheckbox' + personDocumentID;
      let ctrl = document.querySelector(ctrlID);
      let qcVerifiedIsChecked = ctrl.checked;

      // console.log('qcVerifiedIsChecked = ', qcVerifiedIsChecked);

      axios
        .post(store.webAPIUrl + "PersonDocument/updatePersonDocumentQcVerified/" +
          personDocumentID + "/" + qcVerifiedIsChecked)
        .then((response) => response.data)
        .then(() => {

          if (this.$data.showAllRecords) {
            this.getGridDataAll();
          } else {
            this.getGridDataUnique();
          }
        });
    },
    
    downloadDocument(args) {

      let fileName  = args.itemArg['documentGuid'] + args.itemArg['documentMimeType'];
      let friendlyName = args.itemArg['documentName'];
      let docname   = args.itemArg['documentGuid'];
      let extension = args.itemArg['documentMimeType'];

      // console.log('fileName = ', fileName);

      axios.defaults.withCredentials = true;
      axios
        .get(store.webAPIUrl + "File/DownloadDocument/" +
        docname + "/" + extension, {responseType: 'blob'})
        .then((response) => {
          return response.data;
        })
        .then((data) => {

          var file = new Blob([data]);
          let fileURL = URL.createObjectURL(file)

          let link = document.createElement('a');
          link.href = fileURL;
          link.download = friendlyName;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        });
    },

  },
};
</script>

<style scoped>
    .highlightRed {
        color: #DC143C;
    }

.flexRowNoWrapCenter {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.itemCenterCenter {
  display: flex;
  align-items: center;
  justify-content: start;
}

.activeAgency {
  display: inline-block;
  cursor: pointer;
}

.mainPageDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;


}

.pageHeader {
  font-size: 24px;
}

.subHeaderFont {
  font-size: 18px;
}

.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

.radioheaderadjustment {
  padding: 5px;
  margin-top: 5px;
  display: inline-block;
}

.radioFirstLeftMargin {
  margin-left: 40px;
}

.radioOtherLeftMargin {
  margin-left: 20px;
}

.lableMargin {
  margin-left: 5px;
}

/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

.cancelButton {
  background: #6d757c;
  color: white;
  border-radius: 6px;
  margin-left: 10px;
  cursor: pointer;
}

.cancelButton:Hover {
  background: #4e5257;
  color: white;
}

option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.headerMainContainer {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 10% 80% 10%;
}

.cancelModalX {
  cursor: pointer;
}

.xmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 50px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 35% 65%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.xmodal-container-content {
  background-color: #fefefe;
  margin: auto;

  padding: 20px;
  border: 1px inset black;

  width: 25%;
  height: 45%;

  min-height: 500px;
  max-height: 650px;

  min-width: 900px;
  max-width: 1000px;

  margin-bottom: 250px;
  overflow-x: auto;
}

/* ---------- header and footer ---------- */

.xmodal-title {
  text-align: left;
  margin-left: 10px;
  font-size: x-large;
}

.xmodal-footer {
  text-align: center;
}

/* ---------- buttons ---------- */

.xmodal-button-Radius {
  border-radius: 6px;
}

/* **** cancel btn */

.xmodal-cancelButton {
  cursor: pointer;
}

/* **** submit btn */

.xmodal-yesSubmitButton {
  margin-left: 10px;
  cursor: pointer;
}

.xmodal-yesSubmitButton:hover {
  background-color: rgb(19, 64, 0);
  color: white;
}

/* ---------- hr separators ---------- */

.xmodal-hr-top {
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

.xmodal-hr-bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

/* ---------- validation ---------- */

.xmodal-outer-div {
  margin: 5px;
  display: grid;
  grid-template-columns: 80%;
  align-items: center;
  justify-content: center;
}

.xmodal-inner-div {
  margin: 0 auto;
}

.xmodal-li-validation {
  text-align: left;
  margin-top: 15px;
  color: black;
  width: 400px;
}

.xmodal-required-asterisk {
  margin-left: 2px;
  font-size: x-large;
}

/* ---------- content elements ---------- */

.xmodal-textbox-padding {
  padding: 5px;
}

.xmodal-control-labels {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: black;
}

.xmodal-content-justify-right {
  display: flex;
  justify-content: right;
  padding-right: 10px;
}

.xmodal-content-justify-left {
  display: flex;
  justify-content: left;
  align-items: center;
}

/* --------------------------------------------- */
/* -------------- end Modal style -------------- */
/* --------------------------------------------- */

</style>
